import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import cache from './cache'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  const requestObj = {
    url: config.url,
    data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
    time: new Date().getTime()
  }
  const sessionObj = cache.session.getJSON('sessionObj')
  if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
    cache.session.setJSON('sessionObj', requestObj)
  } else {
    const s_url = sessionObj.url // 请求地址
    const s_data = sessionObj.data // 请求数据
    const s_time = sessionObj.time // 请求时间
    const interval = 1000 // 间隔时间(ms)，小于此时间视为重复提交
    if (s_data === requestObj.data &&
      requestObj.time - s_time < interval &&
      s_url === requestObj.url &&
      s_url !== '/umsImage/getImageListById' &&
      s_url !== '/umsSpots/getSpotsListById'
    ) {
      const message = '数据正在处理，请勿重复提交';
      console.warn(`[${s_url}]: ` + message)
      return Promise.reject(new Error(message))
    } else {
      cache.session.setJSON('sessionObj', requestObj)
    }
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    if (response.request.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
      // 401:未登录;
      if (res.code === 401) {
        store.dispatch('FedLogOut').then(() => {
          location.reload()// 为了重新实例化vue-router对象 避免bug
        })
      }
      if (res.code === 500) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('error')
      }
    } else {
      return response.data
    }
  },
  error => {
    const status = error.response ? error.response.status : false// 401
    const code = error.code == 'ECONNABORTED'
    if (!code && status == 401) {
      Message({
        message: '长时间未操作session超时，请重新登录！',
        type: 'error',
        duration: 3 * 1000
      })
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js